import { render } from "./DesignerTable.vue?vue&type=template&id=2b4914d1&scoped=true"
import script from "./DesignerTable.vue?vue&type=script&lang=js"
export * from "./DesignerTable.vue?vue&type=script&lang=js"

import "./DesignerTable.vue?vue&type=style&index=0&id=2b4914d1&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4914d1"]])

export default __exports__